const $ = require('jquery');

module.exports = function () {
    return {
        restrict: 'A',
        scope: false,
        link(scope, element) {
            const $element = $(element);
            const LOADING_CLASS = 'state-loading';

            function getStateClass(stateName) {
                return 'state-' + stateName.replace(new RegExp('[.]', 'g'), '-');
            }

            scope.$on('$stateChangeStart', (evt, toState, toParams, fromState) => {
                $element.removeClass(getStateClass(fromState.name));
                $element.addClass(LOADING_CLASS);
            });

            scope.$on('$stateChangeSuccess', (evt, toState) => {
                $element.addClass(getStateClass(toState.name));
                $element.removeClass(LOADING_CLASS);
            });
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/state-class/state-class-directive.js
 **/